import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Tabs } from "antd";
import { hasPrivilege } from "../api/token";
import ModemManufactureList from "../components/ModemManufactureList";
import ModemUsedList from "../components/ModemUsedList";
import { withLocale } from './../l10n';

function ModemList(props) {
  const navigate = useNavigate();
  const modem_view = hasPrivilege('modem_view');

  useEffect(() => {
    if (!modem_view) {
      navigate("/");
    }
  }, [navigate, modem_view])

  const params = useParams();

  const items = [
    { label: props.lang.handle('Libres'), key: '1', children: <ModemManufactureList /> },
    { label: props.lang.handle('Transformados'), key: '2', children: <ModemUsedList /> },
  ]

  if (modem_view) {
    return (<Tabs
      type="card"
      activeKey={params.tab}
      items={items}
      destroyInactiveTabPane
      onChange={key => {
        navigate(`/modems/list/${key}`)
      }} />)
  }
}

export default withLocale(ModemList);
